import React from 'react';
import OrganizationModal from 'shared/components/OrganizationModal';
import COButton from 'shared/components/COButton';
import WarningIcon from 'assets/ColorIcons/PNG/warning_alert.png';
import AddYearModalBody from './AddYearModalBody';
import styles from './modals.module.scss';

interface ActivityDataEntryModalsProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  initialValues: {
    fromMonth: string;
    fromYear: string;
    toMonth: string;
    toYear: string;
  };
  yearOptions: {
    label: string;
    value: string;
  }[];
  handleYearChangeWrapper: (
    value: string,
    setFieldValue: (
      field: string,
      value: string,
      shouldValidate?: boolean | undefined
    ) => void
  ) => void;
  handleSubmitWrapper: (values: {
    fromMonth: string;
    fromYear: string;
    toMonth: string;
    toYear: string;
  }) => void;
  yearLoading: boolean;
  isAlert: boolean;
  setIsAlert: (value: boolean) => void;
  isCreateProductModal: boolean;
  setIsCreateProductModal: (value: boolean) => void;
  hanldeProductRedirection: () => void;
  handleBack: () => void;
  isCancelModal: boolean;
  handleCancelModalClose: () => void;
}

const ActivityDataEntryModals: React.FC<ActivityDataEntryModalsProps> = ({
  isModalOpen,
  setIsModalOpen,
  initialValues,
  yearOptions,
  handleYearChangeWrapper,
  handleSubmitWrapper,
  yearLoading,
  isAlert,
  setIsAlert,
  isCreateProductModal,
  setIsCreateProductModal,
  hanldeProductRedirection,
  handleBack,
  isCancelModal,
  handleCancelModalClose,
}) => {
  return (
    <>
      {/* Add Year Modal */}
      <OrganizationModal
        title="Add Year"
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        children={
          <AddYearModalBody
            initialValues={initialValues}
            yearOptions={yearOptions}
            handleYearChangeWrapper={handleYearChangeWrapper}
            handleSubmitWrapper={handleSubmitWrapper}
            setIsModalOpen={setIsModalOpen}
            yearLoading={yearLoading}
          />
        }
      />

      {/* Alert Modal */}
      <OrganizationModal
        visible={isAlert}
        onClose={() => setIsAlert(false)}
        children={
          <div className={styles.alertContainer}>
            <div className={styles.alertIconContainer}>
              <img src={WarningIcon} alt="Warning Icon" />
            </div>
            <div className={styles.alertTextContainer}>
              Please Save your scope data before switching tabs
            </div>
            <div className={styles.alertButtonContainer}>
              <COButton secondary onClick={() => setIsAlert(false)}>
                Go back
              </COButton>
            </div>
          </div>
        }
        width={500}
      />

      {/* Create Product Modal */}
      <OrganizationModal
        visible={isCreateProductModal}
        onClose={() => setIsCreateProductModal(false)}
        children={
          <div className={styles.createProductContainer}>
            <div className={styles.createProductTitleContainer}>
              You can now create a product to calculate its carbon footprint.
            </div>
            <div className={styles.createProductInfoContainer}>
              You have the option to create a product, or you may continue by
              providing additional organization details
            </div>
            <div className={styles.buttonContainer}>
              <COButton primary onClick={hanldeProductRedirection}>
                Create product
              </COButton>
              <COButton secondary onClick={handleBack}>
                Go back
              </COButton>
            </div>
          </div>
        }
      />

      {/* Cancel Modal */}
      <OrganizationModal
        visible={isCancelModal}
        onClose={handleCancelModalClose}
        children={
          <div className={styles.cancelModalContainer}>
            <div className={styles.alertIconContainer}>
              <img src={WarningIcon} alt="Warning Icon" />
            </div>
            <div className={styles.cancelTitleTextContainer}>
              Are you sure you want to close the form?
            </div>
            <div className={styles.canceInfoContainer}>
              Closing the form will result in the loss of data entered in the
              activity data entry form only.
            </div>
            <div className={styles.buttonContainer}>
              <COButton danger onClick={handleBack}>
                Cancel
              </COButton>
              <COButton secondary onClick={handleCancelModalClose}>
                Go back
              </COButton>
            </div>
          </div>
        }
      />
    </>
  );
};

export default ActivityDataEntryModals;
